import CatalogCrud, { TextField, ActiveToggleRow } from "./CatalogCrud";

const BLANK = {
  name: "",
  region: "us-east-1",
  bucketName: "",
  objectKey: "",
  objectPrefix: "",
  accessKey: "",
  secretKey: "",
  fileName: "",
  isActive: true,
};

function snapshotFrom(item) {
  return {
    name: item.name ?? "",
    region: item.region ?? "",
    bucketName: item.bucketName ?? "",
    objectKey: item.objectKey ?? "",
    objectPrefix: item.objectPrefix ?? "",
    accessKey: item.accessKey ?? "",
    secretKey: item.secretKey ?? "",
    fileName: item.fileName ?? "",
    isActive: !!item.isActive,
  };
}

function validate(snap) {
  if (!snap.name.trim()) return "Informe o nome.";
  if (!snap.region.trim()) return "Informe a região.";
  if (!snap.bucketName.trim()) return "Informe o bucket.";
  return null;
}

export default function S3ConfigList() {
  return (
    <CatalogCrud
      title="S3 Configurations"
      description="Buckets S3 usados para backup e restore de banco/código."
      endpoint="/admin/s3-configurations"
      duplicateEnabled
      duplicateSuccessMsg="Configuração de S3 duplicada com sucesso"
      itemSubtitle={(item) => [item.region, item.bucketName].filter(Boolean).join(" · ") || null}
      blank={BLANK}
      snapshotFrom={snapshotFrom}
      validate={validate}
      renderForm={({ form, update, saving }) => (
        <>
          <TextField
            label="Nome"
            value={form.name}
            onChange={(v) => update("name", v)}
            placeholder="Ex: Backup Qualitycert"
            disabled={saving}
            required
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <TextField
              label="Region"
              value={form.region}
              onChange={(v) => update("region", v)}
              placeholder="us-east-1"
              disabled={saving}
              required
            />
            <TextField
              label="Bucket name"
              value={form.bucketName}
              onChange={(v) => update("bucketName", v)}
              placeholder="bkp-…"
              disabled={saving}
              required
              mono
            />
            <TextField
              label="Object key"
              value={form.objectKey}
              onChange={(v) => update("objectKey", v)}
              placeholder="backup-específico.bak"
              disabled={saving}
              mono
              helper="Preencha quando quiser baixar um arquivo fixo."
            />
            <TextField
              label="Object prefix"
              value={form.objectPrefix}
              onChange={(v) => update("objectPrefix", v)}
              placeholder="BD-ERP/"
              disabled={saving}
              mono
              helper="Para baixar o mais recente dentro deste prefixo."
            />
            <TextField
              label="Access key"
              value={form.accessKey}
              onChange={(v) => update("accessKey", v)}
              placeholder="AKIA…"
              type="password"
              disabled={saving}
              mono
            />
            <TextField
              label="Secret key"
              value={form.secretKey}
              onChange={(v) => update("secretKey", v)}
              placeholder="…"
              type="password"
              disabled={saving}
              mono
            />
            <div className="sm:col-span-2">
              <TextField
                label="File name"
                value={form.fileName}
                onChange={(v) => update("fileName", v)}
                placeholder="latest-full-backup.bak"
                disabled={saving}
                mono
                helper="Nome que o arquivo terá após o download."
              />
            </div>
          </div>

          <ActiveToggleRow
            checked={form.isActive}
            onChange={(v) => update("isActive", v)}
            disabled={saving}
            label="Configuração ativa"
            description="Desative para ocultar esta configuração da seleção em novos ambientes."
          />
        </>
      )}
    />
  );
}
